export default {
  install(Vue) {
    const _timeObj = Vue.observable({ timeLimit: 28800, timePassed: 0 });
    Object.defineProperty(Vue.prototype, "$timer", {
      get() {
        return _timeObj;
      },
      set(timeObj) {
        _timeObj.timeLimit = timeObj.timeLimit;
        _timeObj.timePassed = timeObj.timePassed;
      }
    });
    Vue.prototype.$startCountdown = () => {
      Vue.prototype.$timer.timePassed += 1;
    };
    Vue.prototype.$clearCountdown = () => {
      Vue.prototype.$timer.timePassed = 0;
    };
  }
};



// WEBPACK FOOTER //
// ./src/plugins/timer.js